module.exports = __webpack_public_path__ + "static/media/yuemeishan_web.2995922a.webp";